import request from '../utils/request';
/**
 * Start
 * 用户管理
 */


export const applicationCopyInfo = data => {
    return request.axiosGet({
        url: '/application/copyInfo',
        params: data
    });
};


export const toyFindListByUserId = data => {
    return request.axiosGet({
        url: '/toy/findListByUserId',
        params: data
    });
};



export const toyList = data => {
    return request.axiosGet({
        url: '/toy/total',
        params: data
    });
};

export const userRecordsAppVersion = data => {
    return request.axiosGet({
        url: '/user-login-records/app-version-total',
        params: data
    });
};

export const userRecordsUserTotal = data => {
    return request.axiosGet({
        url: '/user-login-records/user-total',
        params: data
    });
};

export const userRecordsList = data => {
    return request.axiosGet({
        url: '/user-login-records/list',
        params: data
    });
};


export const applicationList = data => {
    return request.axiosGet({
        url: '/application/list',
        params: data
    });
};


export const userLogin = data => {
    return request.axiosPost({
        url: '/background/user/login',
        data: data
    });
};
export const logout = data => {
    return request.axiosPost({
        url: '/background/user/logout',
        data: data
    });
};
export const userPage = data => {
    return request.axiosGet({
        url: '/background/user/page/back',
        params: data
    });
};
export const appUserPage = data => {
    return request.axiosGet({
        url: '/background/user/page',
        params: data
    });
};
export const userPageVisitor = data => {
    return request.axiosGet({
        url: '/background/user/page/visitor',
        params: data
    });
};
export const userAdd = data => {
    return request.axiosPut({
        url: '/background/user/addBackUser',
        data: data
    });
};
export const updateUser = data => {
    return request.axiosPost({
        url: '/background/user/updateUser',
        data: data
    });
};
export const userresetPassword = data => {
    return request.axiosPost({
        url: '/background/user/resetPassword',
        data: data
    });
};
export const removeUser = id => {
    return request.axiosDelete({
        url: '/background/user/remove/' + id
    });
};

// 国家配置
export const countryAdd = data => {
    return request.axiosPut({
        url: '/country/add',
        data: data
    });
};

export const countryList = data => {
    return request.axiosGet({
        url: '/country/list'
    });
};
export const countryPage = data => {
    return request.axiosGet({
        url: '/country/page',
        params: data
    });
};
export const countryRemove = id => {
    return request.axiosDelete({
        url: '/country/remove/' + id
    });
};
export const countryUpdate = data => {
    return request.axiosPost({
        url: '/country/update',
        data: data
    });
};

// 短信发送配置
export const shortMsgAdd = data => {
    return request.axiosPut({
        url: '/shortMsg/config/add',
        data: data
    });
};
export const shortMsgPage = data => {
    return request.axiosGet({
        url: '/shortMsg/config/page',
        params: data
    });
};
export const shortMsgRemove = id => {
    return request.axiosDelete({
        url: '/shortMsg/config/remove/' + id
    });
};
export const shortMsgUpdate = data => {
    return request.axiosPost({
        url: '/shortMsg/config/update',
        data: data
    });
};
// 邮箱SMTP服务器配置
export const emailSmtpAdd = data => {
    return request.axiosPut({
        url: '/emailSmtp/config/add',
        data: data
    });
};

export const emailSmtpPage = data => {
    return request.axiosGet({
        url: '/emailSmtp/config/page',
        params: data
    });
};
export const emailSmtpRemove = id => {
    return request.axiosDelete({
        url: '/emailSmtp/config/remove/' + id
    });
};
export const emailSmtpUpdate = data => {
    return request.axiosPost({
        url: '/emailSmtp/config/update',
        data: data
    });
};
//用户反馈意见
export const proposedPage = data => {
    return request.axiosGet({
        url: '/proposed/page',
        params: data
    });
};
export const proposedReply = data => {
    return request.axiosPost({
        url: '/proposed/reply',
        data: data
    });
};
export const proposedDelete = id => {
    return request.axiosDelete({
        url: '/proposed/delete/'+id,
    });
};
//统计
export const activeStatistics = data => {
    return request.axiosGet({
        url: '/visitor/function/active/statistics',
        params: data
    });
};
export const statisticsUser = data => {
    return request.axiosGet({
        url: '/visitor/statistics/user',
        params: data
    });
};
export const activeUser = data => {
    return request.axiosGet({
        url: '/visitor/year/active/user',
        params: data
    });
};
export const statistical = data => {
    return request.axiosGet({
        url: '/visitor/year/appFunction/statistical',
        params: data
    });
};
export const registerUser = data => {
    return request.axiosGet({
        url: '/visitor/year/register/user',
        params: data
    });
};
export const allStatistics = data => {
    return request.axiosGet({
        url: '/visitor/all/statistics',
        params: data
    });
};
export const mapUserTotal = data => {
    return request.axiosGet({
        url: '/visitor/mapUserTotal',
        params: data
    });
};
export const countryStatistics = data => {
    return request.axiosGet({
        url: '/visitor/user/country/statistics',
        params: data
    });
};
export const remoteStatistics = data => {
    return request.axiosGet({
        url: '/visitor/user/remote/statistics',
        params: data
    });
};
export const phoneStatistics = data => {
    return request.axiosGet({
        url: '/visitor/user/Phone/statistics',
        params: data
    });
};
export const genderStatistics = data => {
    return request.axiosGet({
        url: '/visitor/user/gender/statistics',
        params: data
    });
};

//菜单
export const menuAdd = data => {
    return request.axiosPut({
        url: '/sys-menu/add',
        data: data
    });
};
export const menuUpdate = data => {
    return request.axiosPost({
        url: '/sys-menu/update',
        data: data
    });
};
export const menuRemove = id => {
    return request.axiosDelete({
        url: '/sys-menu/remove/' + id
    });
};
export const menuTree = data => {
    return request.axiosGet({
        url: '/sys-menu/tree',
        params: data
    });
};
export const menuButton = data => {
    return request.axiosGet({
        url: '/sys-menu/button/list',
        params: data
    });
};

//角色
export const roleAdd = data => {
    return request.axiosPut({
        url: '/sys-role/add',
        data: data
    });
};
export const roleUpdate = data => {
    return request.axiosPost({
        url: '/sys-role/update',
        data: data
    });
};
export const roleRemove = id => {
    return request.axiosDelete({
        url: '/sys-role/remove/' + id
    });
};
export const roleList = data => {
    return request.axiosGet({
        url: '/sys-role/list',
        params: data
    });
};
export const allMenu = data => {
    return request.axiosGet({
        url: '/sys-role/allMenu',
        params: data
    });
};
export const roleDetails = data => {
    return request.axiosGet({
        url: '/sys-role/details',
        params: data
    });
};
export const nodeStatistics = data => {
    return request.axiosGet({
        url: '/visitor/node/statistics',
        params: data
    });
};

// faq
export const faqSave = data => {
    return request.axiosPost({
        url: '/faq/save',
        data: data
    });
};
export const faqSort = data => {
    return request.axiosPost({
        url: '/faq/sort',
        data: data
    });
};
export const faqList = data => {
    return request.axiosGet({
        url: '/faq/list',
        params: data
    });
};
export const faqListByQid = data => {
    return request.axiosGet({
        url: '/faq/listByQid',
        params: data
    });
};
export const faqRemove = id => {
    return request.axiosDelete({
        url: '/faq/remove/'+id,
    });
};

//产品
export const productPage = data => {
    return request.axiosGet({
        url: '/device/product/page',
        params: data
    });
};
export const productSave = data => {
    return request.axiosPost({
        url: '/device/product/save',
        data: data
    });
};
export const productDetails = data => {
    return request.axiosGet({
        url: '/device/product/details',
        params: data
    });
};
export const productDelete = id => {
    return request.axiosDelete({
        url: '/device/product/delete/'+id,
    });
};

//上传文件
export const uploadSingle = data => {
    return request.axiosUpload({
        url: '/file/upload/single',
        data: data
    });
};

//应用管理
export const appList = data => {
    return request.axiosGet({
        url: '/application/list',
        params: data
    });
};
export const appSave = data => {
    return request.axiosPut({
        url: '/application/add',
        data: data
    });
};
export const appUpdate = data => {
    return request.axiosPost({
        url: '/application/edit',
        data: data
    });
};
export const appDelete = id => {
    return request.axiosDelete({
        url: '/application/remove/'+id,
    });
};


//协议管理
export const userAgreementList = data => {
    return request.axiosGet({
        url: '/user-agreement/list',
        params: data
    });
};
export const userAgreementDetails = data => {
    return request.axiosGet({
        url: '/user-agreement/details',
        params: data
    });
};

export const userAgreementSave = data => {
    return request.axiosPut({
        url: '/user-agreement/add',
        data: data
    });
};
export const userAgreementUpdate = data => {
    return request.axiosPost({
        url: '/user-agreement/edit',
        data: data
    });
};
export const userAgreementDelete = id => {
    return request.axiosDelete({
        url: '/user-agreement/remove/'+id,
    });
};
